import script from "./NuovaRilevazione.vue?vue&type=script&setup=true&lang=js"
export * from "./NuovaRilevazione.vue?vue&type=script&setup=true&lang=js"

import "./NuovaRilevazione.vue?vue&type=style&index=0&id=b5c86a70&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\adria\\OneDrive\\Escritorio\\whappy-app-front-vue-v2\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b5c86a70"]])

export default __exports__